import { Grid as MuiGrid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useRef, useState } from 'react';
import Chart from 'react-apexcharts';
import fads from '../../assets/fads.png';
import gads from '../../assets/gads.png';
import AnalyticsBarComponent from './AnalyticsBarComponent';
import MapContainer from './MapContainer';
import {
  getanalyicsbigquery,
  generatechartoptions,
  utmSourceFunc,
  chartOptions_init,
  generatechartoptionsmultipleseries,
  referalDomainsFunc,
  popularPagesFunc,
  utmCampainFunc,
  utmMediumFunc,
} from './utils';
import AnimatedDialog from '../../components/Reusable/AnimatedDialog';

const AttributionStatsComponent = ({
  magnetUuid,
  url,
  // ,chartOptionsfbclicks,totalgclicks,totalfbclicks,chartOptionsgclicks,
  // referrer_domain,popular_pages,utm_campaign,utm_sources,utm_medium
}) => {
  const [screenOpen, setScreenOpen] = useState(false);
  const [thetitle, setthetitle] = useState('');
  const [popupstats, setpopupstats] = useState({});
  const [popupchartloader, setpopupchartloader] = useState(false);
  const [chartOptions, setchartOptions] = useState(chartOptions_init);
  const getISOdate = (subtracteddays) => {
    const currDate = new Date();
    currDate.setDate(currDate.getDate() - subtracteddays);
    let thedate = currDate.toISOString();
    return thedate;
  };

  const [chartOptionspopup, setchartOptionspopup] = useState('');
  const [popular_pages_opentour, setpopular_pages_opentour] = useState([]);
  const [filterdate, setfilterdate] = useState({
    days: 90,
    date: getISOdate(90),
  });

  const [chartOptionsfbclicks, setchartOptionsfbclicks] = useState('');
  const [totalfbclicks, settotalfbclicks] = useState('');
  const [chartOptionsgclicks, setchartOptionsgclicks] = useState('');
  const [totalgclicks, settotalgclicks] = useState('');
  const [utm_campaign, setutm_campaign] = useState();
  const [utm_sources, setutm_sources] = useState();
  const [utm_medium, setutm_medium] = useState();
  const [popular_pages, setpopular_pages] = useState();
  const [referrer_domain, setreferrer_domain] = useState();
  const getMagnet = async () => {
    // get facebook clicks
    let fbclicks_query_res = await getanalyicsbigquery(
      'SELECT timestamp_trunc(`default.events`.`_timestamp`, WEEK) AS `_timestamp`, count(*) AS `count` FROM `default.events` WHERE `default.events`.`_timestamp` >= timestamp_trunc(timestamp_add(current_timestamp(), INTERVAL -' +
        ` ${filterdate.days}` +
        " day), day) AND (`default.events`.`click_id_fbclid` IS NOT NULL AND (`default.events`.`click_id_fbclid` <> '' OR `default.events`.`click_id_fbclid` IS NULL)) AND `magnet_uuid` =" +
        `'${magnetUuid}'` +
        'GROUP BY `_timestamp` ORDER BY `_timestamp` ASC'
    );
    generatechartoptions(
      fbclicks_query_res,
      setchartOptionsfbclicks,
      settotalfbclicks,
      'Ad Clicks'
    );
    // get google clicks
    let gclicks_query_res = await getanalyicsbigquery(
      'SELECT timestamp_trunc(`default.events`.`_timestamp`, WEEK) AS `_timestamp`, count(*) AS `count` FROM `default.events` WHERE `default.events`.`_timestamp` >= timestamp_trunc(timestamp_add(current_timestamp(), INTERVAL -' +
        ` ${filterdate.days}` +
        " day), day) AND (`default.events`.`click_id_gclid` IS NOT NULL AND (`default.events`.`click_id_gclid` <> '' OR `default.events`.`click_id_gclid` IS NULL)) AND `magnet_uuid` =" +
        `'${magnetUuid}'` +
        'GROUP BY `_timestamp` ORDER BY `_timestamp` ASC'
    );
   // console.log('gclicks_query_res', gclicks_query_res);
    generatechartoptions(
      gclicks_query_res,
      setchartOptionsgclicks,
      settotalgclicks,
      'Ad Clicks'
    );
    // get UTM Compaign

    let utm_compaign_query_res = await getanalyicsbigquery(
      'SELECT `default.events`.`utm_campaign` AS `utm_campaign`, count(*) AS `count` FROM `default.events` WHERE (`default.events`.`magnet_uuid` = ' +
        `'${magnetUuid}'` +
        '  AND `default.events`.`utm_campaign` IS NOT NULL) ' +
        'GROUP BY `utm_campaign` ORDER BY `count` DESC, `utm_campaign` ASC '
    );

   // console.log('utm_compaign_query_res', utm_compaign_query_res);
    let utmCampaignData = [];
    utm_compaign_query_res?.res?.map((item) => {
      utmCampaignData = [
        ...utmCampaignData,
        { title: item[0], value: item[1] },
      ];
    });
    setutm_campaign([
      ...utmCampaignData.sort(function (a, b) {
        return b?.value - a?.value;
      }),
    ]);
    // get UTM Sources

    let utm_source_query_res = await getanalyicsbigquery(
      'SELECT `default.events`.`utm_source` AS `utm_source`, count(*) AS `count` FROM `default.events` WHERE (`default.events`.`magnet_uuid` = ' +
        `'${magnetUuid}'` +
        '  AND `default.events`.`utm_source` IS NOT NULL) ' +
        'GROUP BY `utm_source` ORDER BY `count` DESC, `utm_source` ASC '
    );

    let utmSourcesData = [];
    utm_source_query_res?.res?.map((item) => {
      utmSourcesData = [...utmSourcesData, { title: item[0], value: item[1] }];
    });
    setutm_sources([
      ...utmSourcesData.sort(function (a, b) {
        return b?.value - a?.value;
      }),
    ]);

    let utm_medium_res = await getanalyicsbigquery(
      'SELECT `default.events`.`utm_medium` AS `utm_medium`, count(*) AS `count` FROM `default.events` WHERE (`default.events`.`magnet_uuid` = ' +
        `'${magnetUuid}'` +
        '  AND `default.events`.`utm_medium` IS NOT NULL) ' +
        'GROUP BY `utm_medium` ORDER BY `count` DESC, `utm_medium` ASC '
    );

   // console.log('utm_medium_res', utm_medium_res);
    let utmMediumData = [];
    utm_medium_res?.res?.map((item) => {
      utmMediumData = [...utmMediumData, { title: item[0], value: item[1] }];
    });

    setutm_medium([
      ...utmMediumData.sort(function (a, b) {
        return b?.value - a?.value;
      }),
    ]);

    let popular_pages_query_res = await getanalyicsbigquery(
      "SELECT `default.events`.`page_title` AS `page_title`, `default.events`.`doc_path` AS `doc_path`, count(*) AS `count` FROM `default.events` WHERE (`default.events`.`page_title` IS NOT NULL AND (`default.events`.`page_title` <> '' OR `default.events`.`page_title` IS NULL)) AND `default.events`.`magnet_uuid` =" +
        `'${magnetUuid}'` +
        ' AND `default.events`.`_timestamp` > ' +
        `'${filterdate.date}'` +
        'GROUP BY `page_title`, `doc_path` ORDER BY `count` DESC, `page_title` ASC, `doc_path` ASC ' +
        `LIMIT 15`
    );
   // console.log('popular_pages_query_res', popular_pages_query_res);
    let popularpagesData = [];
    popular_pages_query_res?.res?.map((item) => {
      popularpagesData = [
        ...popularpagesData,
        {
          title: item[1],
          subtitle: item[0],
          value: item[2],
          link: url + item[1],
        },
      ];
    });
    setpopular_pages([...popularpagesData.sort((a, b) => b?.value - a?.value)]);

    let res11 = await getanalyicsbigquery(
      "SELECT `default.events`.`page_title` AS `page_title`, `default.events`.`doc_path` AS `doc_path`, count(*) AS `count` FROM `default.events` WHERE (`default.events`.`page_title` IS NOT NULL AND (`default.events`.`page_title` <> '' OR `default.events`.`page_title` IS NULL)) AND `default.events`.`event_type` = 'open_tour' AND `default.events`.`magnet_uuid` =" +
        `'${magnetUuid}'` +
        ' AND `default.events`.`_timestamp` > ' +
        `'${filterdate.date}'` +
        'GROUP BY `page_title`, `doc_path` ORDER BY `count` DESC, `page_title` ASC, `doc_path` ASC'
    );
   // console.log('res11', res11);
    setpopular_pages_opentour(res11.res);
    // get refferer domains
    let refferer_domains_res = await getanalyicsbigquery(
      `select regexp_replace(NET.REG_DOMAIN(referer), r'.*[?&]|"\]$', '') as url, count(url) as Total_Count` +
        " from `default.events` where url != ' '  and `magnet_uuid` = " +
        `'${magnetUuid}'` +
        ' AND `default.events`.`_timestamp` > ' +
        `'${filterdate.date}'` +
        ' group by url order by Total_Count DESC' +
        ` LIMIT 15`
    );

    let mod_referrer_domain = [];
    refferer_domains_res?.res?.map((item) => {
      if (item[0] != null && item[0] != undefined && item[1] != null) {
        mod_referrer_domain = [
          ...mod_referrer_domain,
          { title: item[0], value: item[1] },
        ];
      }
    });
   // console.log('resmod_referrer_domain', mod_referrer_domain);
    // setallreferrerdomainsnames();
    setreferrer_domain(mod_referrer_domain);
  };
  useEffect(() => {
    getMagnet();
  }, []);

  const getreferalDomainsFunc = async (selectedrow) => {
    let referrerdomains = await referalDomainsFunc(
      selectedrow,
      setpopupchartloader,
      setScreenOpen,
      setthetitle,
      generatechartoptions,
      setchartOptionspopup,
      magnetUuid
    );
    setpopupstats(referrerdomains);
    setpopupchartloader(false);
  };
  const getpopularPagesFunc = async (selectedrow) => {
    let popularpages = await popularPagesFunc(
      selectedrow,
      setpopupchartloader,
      setScreenOpen,
      setthetitle,
      generatechartoptions,
      setchartOptionspopup,
      magnetUuid
    );
    setpopupstats(popularpages);
    setpopupchartloader(false);
  };
  const getutmCampainFunc = async (selectedrow) => {
    let utmcompaigns = await utmCampainFunc(
      selectedrow,
      setpopupchartloader,
      setScreenOpen,
      setthetitle,
      generatechartoptions,
      setchartOptionspopup,
      magnetUuid
    );
    setpopupstats(utmcompaigns);
    setpopupchartloader(false);
  };
  const getutmMediumFunc = async (selectedrow) => {
    let utmmediums = await utmMediumFunc(
      selectedrow,
      setpopupchartloader,
      setScreenOpen,
      setthetitle,
      generatechartoptions,
      setchartOptionspopup,
      magnetUuid
    );
    setpopupstats(utmmediums);
    setpopupchartloader(false);
  };
  const getutmSourceFunc = async (selectedrow) => {
    let utmsources = await utmSourceFunc(
      selectedrow,
      setpopupchartloader,
      setScreenOpen,
      setthetitle,
      generatechartoptions,
      setchartOptionspopup,
      magnetUuid
    );
    setpopupstats(utmsources);
    setpopupchartloader(false);
  };

  const Loader = () => {
    return (
      <div className="animate-pulse">
        <div className="flex items-center justify-between pb-3 border-b w-full ">
          <div className=" w-20 h-6 bg-gray-300 rounded-md"></div>
          <div className=" flex items-center gap-3">
            <div className=" w-16 h-8 bg-gray-300 rounded-md"></div>
            <div className=" w-16 h-8 bg-gray-300 rounded-md"></div>
          </div>
        </div>
        <div className=" w-full pr-10">
          <div
            style={{ width: '100%' }}
            className="  bg-gray-300 rounded-md h-8 mb-2"
          ></div>
          <div
            style={{ width: '90%' }}
            className=" w-full bg-gray-300 rounded-md h-8 mb-2"
          ></div>
          <div
            style={{ width: '80%' }}
            className=" w-full bg-gray-300 rounded-md h-8 mb-2"
          ></div>
          <div
            style={{ width: '60%' }}
            className=" w-full bg-gray-300 rounded-md h-8 mb-2"
          ></div>
          <div
            style={{ width: '30%' }}
            className=" w-full bg-gray-300 rounded-md h-8  mb-2"
          ></div>
          <div
            style={{ width: '20%' }}
            className=" w-full bg-gray-300 rounded-md h-8 "
          ></div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <AnimatedDialog
        maxWidth="md"
        open={screenOpen}
        onClose={() => setScreenOpen(false)}
      >
        {popupchartloader ? (
          <div className=" w-full bg-white p-6 rounded-md">
            <h1 className="text-xl pb-3">Loading...</h1>
          </div>
        ) : (
          <>
            <div className="width">
              {chartOptionspopup && <Chart {...chartOptionspopup} />}
            </div>
          </>
        )}
      </AnimatedDialog>
      <div className=" my-6 grid grid-cols-1  lg:grid-cols-2 px-4 gap-3">
        <div>
          <p className=" text-gray-400 text-sm">Sources</p>
          <div className=" mt-4">
            <img src={fads} className="w-24 object-contain" alt="" />
            <h1 className=" text-2xl font-medium my-2">
              {totalfbclicks || (
                <button
                  disabled
                  type="button"
                  className="py-2.5 px-5 mr-2 text-sm font-medium text-gray-900 bg-white rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:outline-none focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 inline-flex items-center"
                >
                  <svg
                    aria-hidden="true"
                    role="status"
                    className="inline mr-2 w-4 h-4 text-gray-200 animate-spin dark:text-gray-600"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="#1C64F2"
                    />
                  </svg>
                  Loading
                </button>
              )}{' '}
              ad clicks
            </h1>
            {chartOptionsfbclicks && (
              <div className=" h-20 pt-2">
                <Chart {...chartOptionsfbclicks} />
              </div>
            )}
          </div>
          <div className=" mt-4">
            <img src={gads} className="w-24 object-contain" alt="" />
            <h1 className=" text-2xl font-medium mt-2">
              {totalgclicks || (
                <button
                  disabled
                  type="button"
                  className="py-2.5 px-5 mr-2 text-sm font-medium text-gray-900 bg-white rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:outline-none focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 inline-flex items-center"
                >
                  <svg
                    aria-hidden="true"
                    role="status"
                    className="inline mr-2 w-4 h-4 text-gray-200 animate-spin dark:text-gray-600"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="#1C64F2"
                    />
                  </svg>
                  Loading
                </button>
              )}{' '}
              ad clicks
            </h1>
            {chartOptionsgclicks && (
              <div className=" h-20 pt-2">
                <Chart {...chartOptionsgclicks} />
              </div>
            )}
          </div>
        </div>
        {referrer_domain ? (
          <AnalyticsBarComponent
            title={'Referral Domains'}
            pagination={5}
            data={referrer_domain}
            primaryColor={`rgba(239, 246, 255,0.8)`}
            onClickFunc={getreferalDomainsFunc}
          />
        ) : (
          <Loader />
        )}
        {popular_pages ? (
          <AnalyticsBarComponent
            title={'Most Popular Pages'}
            pagination={5}
            data={popular_pages}
            primaryColor={`rgba(239, 246, 255,0.8)`}
            onClickFunc={getpopularPagesFunc}
          />
        ) : (
          <Loader />
        )}
        {utm_campaign ? (
          <AnalyticsBarComponent
            title={'UTM Campaigns'}
            pagination={5}
            data={utm_campaign}
            primaryColor={`rgba(239, 246, 255,0.8)`}
            onClickFunc={getutmCampainFunc}
          />
        ) : (
          <Loader />
        )}
        {utm_sources ? (
          <AnalyticsBarComponent
            title={'UTM Sources'}
            pagination={5}
            data={utm_sources}
            primaryColor={`rgba(239, 246, 255,0.8)`}
            onClickFunc={getutmSourceFunc}
          />
        ) : (
          <Loader />
        )}
        {utm_medium ? (
          <AnalyticsBarComponent
            title={'UTM Medium'}
            pagination={5}
            data={utm_medium}
            primaryColor={`rgba(239, 246, 255,0.8)`}
            onClickFunc={getutmMediumFunc}
          />
        ) : (
          <Loader />
        )}
      </div>
    </div>
  );
};

export default AttributionStatsComponent;
